(function () {
  // Quiz Kit fires 'quizKitAddToCartSuccess' after an item is successfully
  // added to the Shopify cart.
  //
  // The theme's cart drawer requires two steps:
  //   1. 'theme:cart:refresh': triggers getCart(), which fetches the latest
  //      cart data from Shopify and rebuilds the drawer HTML.
  //   2. 'theme:product:added': opens the drawer.
  //
  // We dispatch refresh first, then wait 400ms for the fetch to complete
  // before opening the drawer so the updated items are visible.
  document.addEventListener('quizKitAddToCartSuccess', function () {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
    }, 400);
  }, false);

  // Apply image zoom via setProperty('important'). Required because Quiz Kit
  // sets these properties as inline !important styles via its own JavaScript,
  // which cannot be overridden by any stylesheet rule.
  //
  // customSection_27 (square lifestyle photos): contain + scale(1) + aspect-ratio 1/1
  // customSection_26 (collection banner, "The <palette> Collection" + EXPLORE)
  //   on desktop: contain + scale(1)
  // customSection_26 on mobile: cover + scale(1.05), keeps the section compact
  // customSection_28 (circle images) on mobile: cover + scale(1.2), transform-origin center
  // All other images: cover + scale(1.05)
  function applyImageZoom(img) {
    var section = img.closest('#quiz-kit-sections-container > section');
    var sectionId = section && section.getAttribute('data-section-id');
    var isSquareSection = sectionId === 'customSection_27';
    var isBannerDesktop = sectionId === 'customSection_26' && window.innerWidth > 767;
    var isCircleMobile = sectionId === 'customSection_28' && window.innerWidth <= 767;
    var useContain = isSquareSection || isBannerDesktop;
    img.style.setProperty('object-fit', useContain ? 'contain' : 'cover', 'important');
    img.style.setProperty('object-position', 'center', 'important');
    img.style.setProperty('transform', isCircleMobile ? 'scale(1.2)' : (useContain ? 'scale(1)' : 'scale(1.05)'), 'important');
    if (isCircleMobile) {
      img.style.setProperty('transform-origin', 'center', 'important');
    }
    if (isSquareSection) {
      img.style.setProperty('aspect-ratio', '1 / 1', 'important');
    }
  }

  // Re-apply styles when the viewport crosses the 767px breakpoint so that
  // customSection_26 and customSection_28 switch between desktop and mobile behaviour.
  var prevIsMobile = window.innerWidth <= 767;
  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth <= 767;
    if (isMobile !== prevIsMobile) {
      prevIsMobile = isMobile;
      document.querySelectorAll('.quiz-kit-main-image').forEach(applyImageZoom);
    }
  });

  // 1. Apply to any images already in the DOM when this script loads.
  //    Handles the common case where Quiz Kit renders before our deferred script
  //    has a chance to register its event listener.
  document.querySelectorAll('.quiz-kit-main-image').forEach(applyImageZoom);

  // 2. Watch for images added dynamically after script load (React rendering,
  //    hover slideshow, etc.).
  var imageObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('quiz-kit-main-image')) {
          applyImageZoom(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.quiz-kit-main-image').forEach(applyImageZoom);
        }
      });
    });
  });
  imageObserver.observe(document.body, { childList: true, subtree: true });

  // 3. Belt-and-braces: also apply on the results page event in case it fires
  //    after this script loads.
  document.addEventListener('quizKitResultsPageLoaded', function () {
    document.querySelectorAll('.quiz-kit-main-image').forEach(applyImageZoom);
  });
})();
